// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3axeW","studyBtn":"styles_studyBtn__1spVH"};